export default __webpack_public_path__ + "static/media/GroupIMG_122.07ae0751.jpg";